export const HomeIcon = () => {
  return (
    <lord-icon
      src="https://cdn.lordicon.com/gmzxduhd.json"
      title="Home"
      trigger="hover"
      stroke="100"
      colors="primary:#c34d76,secondary:#ffffff"
      style={{
        marginTop: "5rem",
        width: "50px",
        height: "50px",
        paddingTop: "0",
        paddingBottom: "2rem",
      }}
    ></lord-icon>
  );
};
